import { ValidationError } from "sequelize"
import { ACTIVE, INACTIVE } from "const"
import { MtPackage, MtPackageCreate, MtPackageSave, MtPackageChangeStatus } from "server/models"
import { ActiveInactive, OrderType, deepCopy } from "client/utils"
import { GET, POST, sort, search, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    PackageList,
    PackageFilters,
    PackageSettings,
    PackageValidation,
} from "../types"
import { initPackageSettings } from "../reducers"


export const LoadAllPackages = () => (
    GET("/mtPackage/all")
    .then((packages: MtPackage[]) => {
        const packageList: PackageList = {}
        packages.forEach((_package) => {
            packageList[_package.id] = {
                ..._package,
                settingsParsed: ParsePackageSettings(_package),
            }
        })
        return packageList
    })
)

export const LoadAvailablePackages = () => (
    GET("/mtPackage/available")
    .then((packages: MtPackage[]) => packages)
)

export const LoadPackageById = (packageId: number) => (
    GET(`/mtPackage/id/${packageId}`)
    .then((_package: MtPackage): MtPackage => ({
        ..._package,
        settingsParsed: ParsePackageSettings(_package),
    }))
)

export const ParsePackageSettings = (_package: MtPackage) => {
    const newSettings = deepCopy(initPackageSettings)
    const curSettings = _package && _package.settings ? JSON.parse(_package.settings) : {}

    Object.keys(newSettings).forEach((key) => {
        if (curSettings[key]) newSettings[key] = curSettings[key]
    })

    return <PackageSettings>newSettings
}

export const SavePackage = (
    id: number,
    packg: MtPackageCreate,
    lang: LangType,
) => {
    const data: MtPackageSave = {
        id,
        packg,
    }
    return POST(
        "/mtPackage/save",
        JSON.stringify(data),
    ).then((res) => {
        const newPackage = res as MtPackage
        const error = res as ValidationError
        return {
            newPackageId: newPackage.id || null,
            validation: <PackageValidation>validate(error, lang),
        }
    })
}

export const ChangePackageStatus = (packg: MtPackage) => {
    const status: ActiveInactive = packg.status === ACTIVE ? INACTIVE : ACTIVE
    const data: MtPackageChangeStatus = {
        id: packg.id,
        status,
    }
    return POST(
        "/mtPackage/changeStatus",
        JSON.stringify(data),
    ).then((updatedRows: [number]) => (
        updatedRows && updatedRows.length && updatedRows[0] === 1
            ? status
            : packg.status
    ))
}

export const SortPackages = (
    packages: MtPackage[],
    sortColumn: keyof MtPackage,
    sortOrder: OrderType,
    filters: PackageFilters,
): number[] => {
    const packagesFiltered = packages.filter((_package) => {
        let showRow = true
        if (filters.status && _package.status !== filters.status) showRow = false
        if (filters.visibility && _package.visibility !== filters.visibility) showRow = false
        else if (filters.search) showRow = search(filters.search, _package)
        return showRow
    })
    packagesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const packageIds: number[] = []
    packagesFiltered.forEach((_package) => packageIds.push(_package.id))

    return packageIds
}
